import { Box, IconButton, Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: {
    xs: 'calc(100% - 32px)',
    sm: 'calc(100% - 48px)',
    md: '588px'
  },
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: {
    xs: '24px',
    sm: '32px',
    md: '48px'
  },
  borderRadius: '16px',
  maxHeight: '80vh',
  overflowY: 'auto',
};

const ReusableModal = ({ open, onClose, children }: {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={modalStyle}>
        <IconButton sx={{ position: 'absolute', top: 8, right: 8 }} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        {children}
      </Box>
    </Modal>
  );
};

export default ReusableModal;
